import React, { useEffect, useState } from "react";
import { useLocation, Route, useNavigate } from "react-router-dom";
// import './App.scss';
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
// import Sidebar from './shared/Sidebar';
import "./App.css";
import SettingsPanel from "./shared/SettingsPanel";
import Footer from "./shared/Footer";
import { withTranslation } from "react-i18next";
import Dashboard from "./dashboard/Dashboard";
import Login from "./user-pages/Login";
import Buttons from "./basic-ui/Buttons";
import Sidebar1 from "./shared/Sidebar1";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from '@mui/material';
// import SidebarWithLocation from './shared/Sidebar1';
// import SideBarWithLocation from './shared/SideBarWithLocation';

function App() {
  const [isFullPageLayout, setIsFullPageLayout] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const body = document.querySelector("body");

  const user = localStorage.getItem("token");

  console.log('user in App.js',user);

  useEffect(() => {
    const element = document.querySelector(".container-scroller");
    if (element) {
      element.classList.add("active");
    }

    if (location.pathname === "/layout/RtlLayout") {
      body.classList.add("rtl");
    } else {
      body.classList.remove("rtl");
    }

    const fullPageLayoutRoutes = [
      "/",
      "/user-pages/login-1",
      "/user-pages/register-1",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/general-pages/landing-page",
      // "/ticketDashboard/TicketDashboard", // Add this here
    ];


    const isFullPage = fullPageLayoutRoutes.includes(location.pathname);

  // ✅ Include both pathname-based and hash-based detection
  // const fullPageHashRoutes = ["#/tickets-dashboard"];

  // const isFullPage =
  //   fullPageLayoutRoutes.includes(location.pathname) ||
  //   fullPageHashRoutes.includes(window.location.hash); // use window.location.hash

  // console.log("location.pathname:", location.pathname);
  // console.log("window.location.hash:", window.location.hash);
  // console.log("isFullPageLayout:", isFullPage);


  //   console.log("location.hash",location.hash);

  // ✅ Support for hash route like #/tickets-dashboard
  // if (location.hash.toLowerCase() === "#/tickets-dashboard") {
  //   isFullPage = true;
  // }


    setIsFullPageLayout(isFullPage);

    window.scrollTo(0, 0);
  }, [location.pathname, body]);

  return (
    <div className="container-scroller">
      {/* <div> */}
      {user && !isFullPageLayout && <Navbar />}
      <div className="container-fluid page-body-wrapper">
        {/* <div> */}
        {user && !isFullPageLayout && <Sidebar1 />}
        {/* {user && !isFullPageLayout && <Sidebar1 dashboardType="ticket-dashboard" />
} */}

        {/* <div className="container"> */}

        <Container
          sx={{
            maxWidth: "1200px", // Adjust to your preferred width
            // margin: "0 auto",
            marginTop:"65px",
            padding: "0 15px",
            marginLeft:"31px"
          }}
        >
          {/* <div> */}
          {/* <div className="content"> */}
          <div>
            {/*<Dashboard/><Login/> */}
            {!user && <Login />}
            {/* <Buttons/> */}
            {user && <AppRoutes />}

            {/* {user&&!isFullPageLayout && <SettingsPanel />} */}
          </div>
          {/* {user&&!isFullPageLayout && <Footer />} */}
          {/* </div> */}
        </Container>
      </div>
    </div>
  );
}

export default withTranslation()(App);

// import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
// import './App.scss';
// import AppRoutes from './AppRoutes';
// import Navbar from './shared/Navbar';
// import Sidebar from './shared/Sidebar';
// import SettingsPanel from './shared/SettingsPanel';
// import Footer from './shared/Footer';
// import { withTranslation } from "react-i18next";

// // class ErrorBoundary extends Component {
// //   constructor(props) {
// //     super(props);
// //     this.state = { hasError: false };
// //   }

// //   componentDidCatch(error, errorInfo) {
// //     this.setState({ hasError: true });
// //     console.error(error, errorInfo);
// //   }

// //   render() {
// //     if (this.state.hasError) {
// //       return <div>Oops! Something went wrong.</div>;
// //     }
// //     return this.props.children;
// //   }
// // }

// class App extends Component {
//   state = {
//     isFullPageLayout: false,
//   };
//   ref = React.createRef();

//   componentDidMount() {
//     const element = this.ref.current;
//     console.log(element);
//     if (element) {
//       element.classList.add('active');
//       const isFullPageLayout = element.dataset.isFullPageLayout;
//       console.log(isFullPageLayout);

//     }
//   }

//   render () {
//     let navbarComponent = !this.state.isFullPageLayout ? <Navbar/> : '';
//     let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar/> : '';
//     let SettingsPanelComponent = !this.state.isFullPageLayout ? <SettingsPanel/> : '';
//     let footerComponent = !this.state.isFullPageLayout ? <Footer/> : '';
//     return (

//       <div className="container-scroller">
//         { navbarComponent }
//         <div className="container-fluid page-body-wrapper">
//           { sidebarComponent }
//           <div className="main-panel">
//             <div className="content-wrapper">
//               <AppRoutes/>
//               { SettingsPanelComponent }
//             </div>
//             { footerComponent }
//           </div>
//         </div>
//       </div>

//     );
//   }

//   componentDidUpdate(prevProps) {
//     if (this.props.location !== prevProps.location) {
//       this.onRouteChanged();
//     }
//   }

//   onRouteChanged() {
//     console.log("ROUTE CHANGED");
//     const { i18n } = this.props;
//     const body = document.querySelector('body');
//     if(this.props.location.pathname === '/layout/RtlLayout') {
//       body.classList.add('rtl');
//       i18n.changeLanguage('ar');
//     }
//     else {
//       body.classList.remove('rtl')
//       i18n.changeLanguage('en');
//     }
//     window.scrollTo(0, 0);
//     const fullPageLayoutRoutes = ['/user-pages/login-1', '/user-pages/register-1', '/user-pages/lockscreen', '/error-pages/error-404', '/error-pages/error-500', '/general-pages/landing-page'];
//     for ( let i = 0; i < fullPageLayoutRoutes.length; i++ ) {
//       if (this.props.location.pathname === fullPageLayoutRoutes[i]) {
//         this.setState({
//           isFullPageLayout: true
//         })
//         document.querySelector('.page-body-wrapper').classList.add('full-page-wrapper');
//         break;
//       } else {
//         this.setState({
//           isFullPageLayout: false
//         })
//         document.querySelector('.page-body-wrapper').classList.remove('full-page-wrapper');
//       }
//     }
//   }

// }

// export default withTranslation() (withRouter(App));
